import { useState } from 'react';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import { notifyClient } from 'actions/appointments';
import Button from 'atoms/button';
import toast from 'atoms/toast';
import {
  closeNotifyClientModal,
  requestFulfilled,
  requestOngoing,
} from 'store/reducers/ui';

export default function NotifyClientModal() {
  const dispatch = useDispatch();
  const { appointmentNotifyClientModal } = useSelector((state) => state.ui);
  const { animal, user, locationUser, uuid } =
    appointmentNotifyClientModal.appointment;
  const owner = user?.firstName;
  const animalName = animal?.name;
  const groomer = locationUser?.firstName;
  const defaultMessage = `Hi ${owner}, ${animalName} will be ready for pickup within the next 30 minutes. Please pick up ${animalName} no later than an hour from now. — ${groomer}`;
  const [message, setMessage] = useState(defaultMessage);

  const onClose = () => {
    dispatch(closeNotifyClientModal());
  };

  const onNotify = async () => {
    dispatch(requestOngoing());
    dispatch(notifyClient({ apuid: uuid, message })).then(({ success }) => {
      dispatch(requestFulfilled());
      if (success) {
        toast({ text: 'Client notified!' });
        onClose();
      }
    });
  };

  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={appointmentNotifyClientModal.isOpen}
      onRequestClose={onClose}
      className="notify-client-modal"
    >
      <div className="flex-column align-center">
        <h2 className="mb-12 f26">Notify client</h2>
        <p className="mb-24 f15">Let clients know when to pickup their pets</p>
        <textarea
          className="f12 italic c-dark-grey border-light-purple radius-12 mw-332 w-100 py-12 px-16 resize-none mh-unset"
          onChange={(event) => setMessage(event?.target?.value)}
          placeholder="Add message to client"
          rows={3}
          value={message}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
        <div className="flex-row gap-16 mt-32">
          <Button
            size="medium"
            onClick={onNotify}
            text="Notify"
            variant={message && message.length > 0 ? 'default' : 'disabled'}
          />
          <Button
            size="medium"
            variant="reverse"
            onClick={onClose}
            text="Cancel"
          />
        </div>
      </div>
    </ReactModal>
  );
}
